"use client";

type CartStepperProps = {
  step: number;
  onStepChange: (step: number) => void;
};

const steps = ["Cart", "Shipping", "Payment"];

export default function CartStepper({ step, onStepChange }: CartStepperProps) {
  return (
    <div className="flex items-center justify-between border-b border-gray-300 bg-white px-4 pt-5 pb-4">
      {steps.map((label, index) => {
        const isActive = index === step;
        const isCompleted = index < step;

        return (
          <button
            key={label}
            onClick={() => onStepChange(index)}
            className="flex-1 group">
            <div className="flex flex-col items-center text-xs sm:text-sm">
              {/* Step Icon */}
              <div
                className={`w-6 h-6 rounded-full flex items-center justify-center border transition-all duration-200
                ${
                  isActive
                    ? "bg-black text-white border-black"
                    : isCompleted
                      ? "bg-green-600 text-white border-green-600"
                      : "text-gray-400 border-gray-300"
                }`}>
                {isCompleted ? "✓" : index + 1}
              </div>

              {/* Step Label */}
              <span
                className={`mt-1 font-medium transition-colors duration-200 ${
                  isActive
                    ? "text-black"
                    : isCompleted
                      ? "text-green-600"
                      : "text-gray-400"
                }`}>
                {label}
              </span>
            </div>
          </button>
        );
      })}
    </div>
  );
}
